export interface BuildInfoResponse {
  buildTimeUtc: string | null // ISO 8601 with offset, e.g. "2026-09-01T14:50:44.49+00:00"
  informationalVersion: string // "1.0.0+<commit sha>"
  assemblyVersion: string // "1.0.0.0"
  commitSha: string | null
}

// Empty base => relative URLs, same as api/weather.ts.
const API_BASE = import.meta.env.VITE_API_BASE_URL ?? ''

// GET /api/buildtime — what the API reports about its own build. Anonymous, so
// the login screen can call it before anyone has signed in.
export async function getBuildInfo(): Promise<BuildInfoResponse> {
  const res = await fetch(`${API_BASE}/api/buildtime`)
  if (!res.ok) {
    throw new Error(`Build info API returned ${res.status}`)
  }
  return (await res.json()) as BuildInfoResponse
}
